import React, { useContext } from 'react';
import { Form, Divider, Input } from 'antd';
import './Changepass.scss';
import { FormInstance } from 'antd/lib/form';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
export type IchangePassProps = {
  form: FormInstance;
  onFormFinish: (values: any) => void;
};

const Changepass: React.FC<IchangePassProps> = observer(props => {
  const {
    AuthStore: {
      state: {
        data: { user }
      }
    }
  } = useContext(rootContext);
  return (
    <div className="ChangepassStyles">
      <div className="profile">
        <img src={user?.url} alt="user" />
        <h4>{user?.username}</h4>
        <p>{user?.email}</p>
      </div>
      <Divider>Change Password</Divider>

      <Form layout="vertical" form={props.form} onFinish={props.onFormFinish}>
        <Form.Item
          name="oldPassword"
          label="Old Password"
          rules={[
            {
              required: true,
              message: 'Please input your password!'
            }
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="New Password"
          rules={[
            {
              required: true,
              message: 'Please input new password!'
            },
            {
              pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
              message:
                'Password must contain 8 letter and one uppercase, one lowercase, one special character, one number'
            }
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Please confirm your password!'
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  'The two passwords that you entered do not match!'
                );
              }
            })
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </div>
  );
});

export default Changepass;
